import { L } from 'harmony-language';
import React from 'react';
import { OrgQueryKeys } from '../../../api/config';
import { useAddOrganizationResourceMutation } from '../../../api/mutations/add/use-add-organization-resource-mutation';
import { useEditOrganizationResourceMutation } from '../../../api/mutations/edit/use-edit-organization-resource-mutation';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { CreateDriverProperty, DriverProperty, EditCreateComponentProps } from '../../../types';
import { ResourcePage } from '../resource-page';
import { EditCreateDriverProperty } from './edit-create-driver-property';
import { useDriverPropertyColumns } from './use-driver-property-columns';

export const DriverPropertyManagement = () => {
    const { data: driverProperties = [], isLoading } = useOrganizationQuery<DriverProperty[]>(OrgQueryKeys.driverProperties);
    const { mutateAsync: addDriverProperty, isLoading: isCreating } = useAddOrganizationResourceMutation(OrgQueryKeys.driverProperties, L.driverProperty());
    const { mutateAsync: editDriverProperty, isLoading: isUpdating } = useEditOrganizationResourceMutation(OrgQueryKeys.driverProperties, L.driverProperty());
    const columns = useDriverPropertyColumns();

    function onSubmit(driverProperty: DriverProperty | CreateDriverProperty, closeModal: () => void) {
        if ('id' in driverProperty) {
            editDriverProperty(driverProperty).then(closeModal);
        } else {
            addDriverProperty(driverProperty).then(closeModal);
        }
    }

    return (
        <ResourcePage
            resourceType='driverProperty'
            isLoading={isLoading || isCreating || isUpdating}
            titleFunc={(driverProperty: DriverProperty) => driverProperty.name}
            data={driverProperties}
            columns={columns}
            EditCreateComponent={(editCreateProps: EditCreateComponentProps<DriverProperty>) =>
                <EditCreateDriverProperty
                    existingResource={editCreateProps.resource}
                    onSubmit={(driverProperty) => onSubmit(driverProperty, editCreateProps.closeModal)}
                />
            }
        />
    );
};